import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=bfa922a2&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=bfa922a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa922a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa922a2')) {
      api.createRecord('bfa922a2', component.options)
    } else {
      api.reload('bfa922a2', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=bfa922a2&scoped=true&", function () {
      api.rerender('bfa922a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-491pOYmFnu1oI/JS/comp/CookieBox.vue"
export default component.exports